export enum PlaceStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
